<template>
  <div class="makeItHappem">
    

    <cqtextimagesection direction = "L" :imagesrc="images.time" showTLRBorder="true">
        
        <h5> <b class="red"> MAKE IT HAPPEN FRAMEWORK&copy; </b> </h5>
        <cq-paratext> Manan has invested over a decade to capture the essence of his discoveries &amp; learnings into what is popularly known as the '<b class="red">Make It Happen Framework&copy;</b>'. It took him 11 years to come up with this flow chart that is now universally capable of solving all problems that a person faces in accomplishing any goal. </cq-paratext>
        <cq-paratext> This is proof that when a person develops a specific relationship with (Habits): <b class="red"> Time, Focus, Clarity &amp; Reality </b>, any result can be achieved, however impossible it is perceived to be. </cq-paratext>
        <cq-paratext> <b class="red"> NO HOLLOW WORDS. </b> </cq-paratext>
        <cq-paratext> <b class="red"> Over 3,000 goals </b> have been successfully completed using this Framework in the last 3 years, alone uaing this Framework. </cq-paratext>
        <cq-btn class="text-center pb-5">SEE FOR YOURSELF</cq-btn>
        
    </cqtextimagesection>
  </div>
</template>

<script>

import CQPara from '../../components/ui/CQPara.vue'
import CQButton from '../../components/ui/CQButton.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Image
import time from '../../assets/image/mv/time.png'

export default {
    components:{
        'cq-paratext' : CQPara,
        'cq-btn' : CQButton,
        'cqtextimagesection': CQTextImageSection,
    },
    data() {
    return {
        images: { 
            time,
        }
    }
  }
}
</script>

<style scoped>
  .makeItHappem >>> .red{
    color: var(--primary-color);
    font-size: 20px;
  }

  .makeItHappem >>> h5{
    font-family: 'Seravek-Medium'; 
    font-size: 20px;
    padding-bottom: 3%;
  }

  .makeItHappem >>> h5{
    padding-bottom: 3%;
  }
  
/* Desktop View */
@media only screen and (min-width: 992px){
  .makeItHappem >>> #manan-img{
    padding: 30px 0 0 30px;
  }
}

/* Mobile View */
@media only screen and (max-width: 992px){
  .makeItHappem >>> .random-img{
    padding-bottom: 10%; 
  }

  .makeItHappem >>> .red{
    font-size: 18px;
  }
}
</style>